import { useTranslation } from 'react-i18next';
import { cn, LsbUtils, PaletteUtils } from '@shared/utils';
import type { GetInquiryResponse } from '@shared/api';
import { Text } from '@shared/widgets';

interface TravelDetailsProps {
  className?: string;
  inquiry: GetInquiryResponse;
}

export const TravelDetails = (props: TravelDetailsProps) => {
  const { t } = useTranslation('travel');

  const json = LsbUtils.parseInjuryJson(props.inquiry.json);
  const details = [
    { label: t('travelDetails.labels.services'), value: json?.servicesRequired?.join(', ') || '-' },
    { label: t('travelDetails.labels.travellers'), value: json?.numberOfTravellers || '-' },
    { label: t('travelDetails.labels.from'), value: json?.from || '-' },
    { label: t('travelDetails.labels.to'), value: json?.to || '-' },
    {
      label: t('travelDetails.labels.dates'),
      value: json?.departureDate && json?.returnDate ? LsbUtils.formatDatesRange(json.departureDate, json.returnDate) : '-',
    },
    { label: t('travelDetails.labels.requirements'), value: json?.requirements || '-' },
  ];
  return (
    <section
      className={cn(
        'flex h-fit flex-col gap-6 bg-white p-6 dark:bg-soft-black',
        PaletteUtils.isVcfcPalette && 'rounded-xl dark:border dark:border-gray-black',
        props.className,
      )}
    >
      <Text tag='h2' weight='semibold' size='2xl'>
        {t('travelDetails.title')}
      </Text>
      <ul className='flex flex-col gap-2'>
        {details.map((detail, idx) => (
          <li key={idx} className={cn('flex gap-16', 'max-md:flex-col max-md:gap-1')}>
            <Text className={cn('w-32 shrink-0', 'max-md:w-auto')} tag='h3' color='gray'>
              {detail.label}
            </Text>
            <Text className='break-words' tag='p'>
              {detail.value}
            </Text>
          </li>
        ))}
      </ul>
    </section>
  );
};
